import React from 'react';

interface IOwnProps {
    header: string
}

type Props = IOwnProps;

class TabItem extends React.Component<Props, {}> {
    public render() {
        return this.props.children;
    }
}

export default TabItem;